import React from 'react';
import {
	Router,
	Route,
	IndexRoute,
	browserHistory
} from 'react-router';

import AppComponent from './app.component';
import HomeComponent from './components/home.component';
import GuideComponent from './components/guide.component';
import ApiComponent from './components/api.component';

export default (
	< Router history = { browserHistory } >
		< Route path = "/" component = { AppComponent } >
			< IndexRoute component = { HomeComponent } / >

			< Route path = "guide" component = { GuideComponent } >
				< Route path = ":id" component = { GuideComponent } / >
			< /Route >

			< Route path = "api" component = { ApiComponent } >
				< Route path = ":id" component = { ApiComponent } / >
			< /Route >
		< /Route >
	< /Router >
);



/** WEBPACK FOOTER **
 ** ./app/router.js
 **/